<template>
  <div>
    <van-nav-bar>
      <template #left>
        <img
          class="leftImg"
          @click="$router.push('/home')"
          src="@/assets/jiantou@2x.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="conten">
      <div class="imgbox">
        <img src="../../assets/jy.png" alt="" />
      </div>
      <h1>该用户禁止访问</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "disablePage",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.leftImg {
  width: 27px;
  height: 44px;
}
.conten {
  position: relative;
  width: 100%;
  height: calc(100vh - 92px);
}
.imgbox {
  position: absolute;
  top: 212px;
  left: 50%;
  transform: translateX(-50%);
  width: 411px;
  height: 253px;
  img {
    width: 100%;
    height: 100%;
  }
}
h1 { position: absolute;
  top: 493px;
  left: 50%;
  transform: translateX(-50%);
  font-family: DOUYU;
  font-weight: normal;
  font-size: 34px;
  color: #212121;
}
</style>
